export default __webpack_public_path__ + "static/media/file_00001 (2).38e575c5.pdf";